import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";

// Map of route path patterns -> human-readable page names.
// Order matters: more specific patterns first.
const TITLE_MAP = [
  { path: "/login", title: "Sign in" },
  { path: "/register", title: "Register" },
  { path: "/forgot", title: "Forgot password" },
  { path: "/reset", title: "Reset password" },
  { path: "/team-setup", title: "Team setup" },

  { path: "/dashboard", title: "Dashboard" },
  { path: "/programme", title: "Programme" },
  { path: "/workbook", title: "Sessions" },
  { path: "/workbook/:id", title: "Sessions" },
  { path: "/my-team", title: "My Team" },
  { path: "/businesses", title: "Businesses" },
  { path: "/target-businesses", title: "Target Businesses" },
  { path: "/ceo-report", title: "CEO Report" },

  { path: "/challenges", title: "Challenge Centre" },
  { path: "/challenges/criteria", title: "Challenge Criteria" },
  { path: "/challenges/:id", title: "Challenge" },

  { path: "/admin/challenges/:cid/scoreboard", title: "Scoreboard" },
  { path: "/admin/leaderboard", title: "Leaderboard" },
  { path: "/admin/uploader", title: "Programme Uploader" },
  { path: "/admin/demo-reset", title: "Demo Reset" },
  { path: "/admin/mentor-slots", title: "Mentor Slots" },
  { path: "/admin/admins", title: "Manage Admins" },
  { path: "/admin/preview-platform", title: "Preview the Platform" },

  { path: "/retrospective", title: "Retrospective" },
  { path: "/journal", title: "Learning Journal" },
  { path: "/library", title: "My Library" },
  { path: "/knowledge", title: "M&A FAQs & Glossary" },
  { path: "/resources", title: "Resource Library" },

  { path: "/survey/opening", title: "Opening Survey" },
  { path: "/survey/exit", title: "Exit Survey" },

  { path: "/teams", title: "Teams" },
  { path: "/content-tracker", title: "Content Tracker" },
  { path: "/roles", title: "C-suite Roles" },
  { path: "/roster", title: "Student Roster" },
  { path: "/frameworks", title: "Framework Tools" },
  { path: "/speakers", title: "Speakers" },
  { path: "/mentors", title: "Mentors" },
  { path: "/mentor-booking", title: "Book a Mentor" },
  { path: "/mentor/dashboard", title: "Mentor Dashboard" },
  { path: "/mentor/teams-progress", title: "Teams Progress" },
  { path: "/final-pitch", title: "Your Final Pitch" },
  { path: "/admin/final-pitches", title: "Final Pitches" },
];

function resolvePageName(pathname) {
  for (const entry of TITLE_MAP) {
    if (matchPath({ path: entry.path, end: true }, pathname)) return entry.title;
  }
  return null;
}

export default function RouteTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const page = resolvePageName(pathname);
    document.title = page ? `iTeams Workbook - ${page}` : "iTeams Workbook";
  }, [pathname]);
  return null;
}
